import _ from 'lodash'
import React from 'react'

import locale_provider_ru from 'antd/lib/locale-provider/ru_RU'
import locale_provider_en from 'antd/lib/locale-provider/en_US'
import locale_provider_es from 'antd/lib/locale-provider/es_ES'
import locale_provider_pt from 'antd/lib/locale-provider/pt_PT'
import locale_provider_tr from 'antd/lib/locale-provider/tr_TR'

import ru from './ru.json'
import en from './en.json'
import es from './es.json'
import pt from './pt.json'
import tr from './tr.json'
import id from './id.json'

import moment from 'moment'
import 'moment/locale/ru'
import 'moment/locale/es'
import 'moment/locale/pt'
import 'moment/locale/tr'
import 'moment/locale/id'

const localePricelists = {
  ru: 105,
  en: 4,
  pt: 114,
  es: 17,
  tr: 27,
  id: 28
}
const locales = {
  ru: ru,
  en: en,
  es: es,
  pt: pt,
  tr: tr,
  id: id
}
const localeNames = {
  ru: 'Русский',
  en: 'English',
  es: 'Español',
  pt: 'Português',
  tr: 'Türkçe',
  id: 'Bahasa Indonesia'
}
const localeProviders = {
  ru: locale_provider_ru,
  en: locale_provider_en,
  es: locale_provider_es,
  pt: locale_provider_pt,
  tr: locale_provider_tr,
  id: locale_provider_en
}

export const e = (msg) => (
  <div>{msg}</div>
)

export const prefixPath = (path, prefix) => {
  if (_.isEmpty(path) && path !== '') {
    return false
  }
  if (!!prefix) {
    return `/${prefix}/${_.trim(path, '/')}`
  } else {
    return `/${_.trim(path, '/')}`
  }
}

export const getLocaleFromPath = (path) => {
  const firstSegment = path.split('/')[1]
  if (!_.isEmpty(l8n.locales[firstSegment])) {
      return firstSegment
  } else {
      return false
  }
}

export const getUrlWithoutLocale = (path) => {
  const locale = getLocaleFromPath(path)
  if (!!locale) {
      return path.split('/')[2]
  } else {
      return path
  }
}

export const switchHtmlLocale = (locale) => {
  const html =  window.document.documentElement
  html.lang = locale
}

export const localizeRoute = (route) => {
  if (route.localize !== false)  { 
    return `/:locale(${l8n.regexp})/${_.trim(route.path, '/')}`
  }
  return route.path
}

var l8n = {}
l8n = Object.assign({}, l8n, locales.en)

l8n.defaultLocale = 'en'
l8n.priceListId = localePricelists[l8n.defaultLocale]
l8n.locale = l8n.defaultLocale
l8n.localeProvider = localeProviders[l8n.defaultLocale]
moment.locale(l8n.defaultLocale)

l8n.urlLocale = false
l8n.browserLocale = false
l8n.queryLocale = false

l8n.locales = locales
l8n.localesList = _.keys(locales)
l8n.localeNames = localeNames
l8n.regexp = _.keys(l8n.locales).join('|')
l8n.langpack = {}

l8n.load = function(locale) {
  if (locales[locale]) {
    Object.assign(l8n, locales.en, locales[locale])
    l8n.locale = locale
    l8n.langpack = locales[locale]
    l8n.localeProvider = localeProviders[locale]
    l8n.priceListId = localePricelists[locale] || localePricelists.ru
    moment.locale(locale)
  } else {
    // console.error('can not find locale', locale);
  }
}

export default l8n


// WEBPACK FOOTER //
// ./src/l8n/index.js